import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/elemental-impurities-reports")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/elemental-impurities-reports", statusCode: 301 }); },
});
